import {loadHtmlScript} from "../utils/loadHtmlScript";

export const loadAdDoorPixel = async () => {
    await loadHtmlScript('https://pubtags.addoor.net/lib/contags/metrics.min.js?site=estrategiasdeinversion.com')
    await loadHtmlScript('https://pubtags.addoor.net/lib/contags/contags.js')
}